// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderV2_root__ECD8_","wrapper":"HeaderV2_wrapper__EEsK0","logo":"HeaderV2_logo__Lfojg","copy":"HeaderV2_copy__r7uMb","mobileHide":"HeaderV2_mobileHide__0g4FO"};